import {
  Box,
  Container,
  Divider,
  SimpleGrid,
  VStack,
  HStack,
  Text,
  Link,
  useColorMode
} from "@chakra-ui/react"
import { Link as RouterLink } from "react-router-dom"
import { Logo } from "../../../Logo"
// import { links } from './_data'
import { useAuth } from "../../../contexts/AuthContext";
import { getColor, brandConfig, getComponent } from "../../../brandConfig";






export const FooterWithFourColumns = () => {
  const { user, isAuthenticated } = useAuth();
  const { colorMode } = useColorMode();

  // Detailed console logging of user data
  // console.log('🦶 Footer Auth State:', {
  //   isAuthenticated,
  //   userData: {
  //     id: user?.id,
  //     name: `${user?.fName} ${user?.lName}`,
  //     email: user?.email,
  //     role: user?.role,
  //     permissions: user?.permissions,
  //     isVerifiedSeller: user?.isVerifiedSeller,
  //     businessDetails: {
  //       name: user?.businessName,
  //       registrationNumber: user?.businessRegistrationNumber
  //     },
  //     addresses: {
  //       shipping: user?.shippingAddresses,
  //       billing: user?.billingAddresses
  //     },
  //     paymentDetails: user?.paymentReceivingDetails,
  //     documents: {
  //       signature: user?.encryptedSignatureIpfsUrl
  //     },
  //     dates: {
  //       created: user?.createdAt,
  //       updated: user?.updatedAt
  //     },
  //     tenantId: user?.tenantId
  //   }
  // });

  const siteLinks = [
    { label: "Why Luna", anchor: "why" },
    { label: "Approach", anchor: "framework" },
    { label: "Services", anchor: "services" },
    { label: "How I Work", anchor: "process" },
    { label: "About", anchor: "about" },
    { label: "Book a Conversation", anchor: "contact" },
  ];

  const accountLinks = [
    ...(isAuthenticated ? [{ label: "Profile", href: "/profile" }] : []),
    ...(isAuthenticated ? [{ label: "Clients", href: "/clients" }] : []),
    ...(isAuthenticated ? [{ label: "Calendar", href: "/calendars" }] : []),
  ];

  const scrollTo = (anchor: string) => {
    const el = document.getElementById(anchor);
    if (el) { el.scrollIntoView({ behavior: "smooth" }); }
    else { window.location.href = `/#${anchor}`; }
  };

  // Debug log for links visibility
  // console.log('🔗 Footer Links State:', {
  //   isAuthenticated,
  //   userPermissions: user?.permissions,
  //   visibleLinks: links.map(group => ({
  //     title: group.title,
  //     links: group.links.map(link => link.label)
  //   }))
  // });

  // Debug log to verify signature URL condition
  // console.log('📜 Membership Agreement State:', {
  //   hasSignature: !!user?.encryptedSignatureIpfsUrl,
  //   signatureUrl: user?.encryptedSignatureIpfsUrl,
  //   userId: user?.id,
  //   membershipLink: user?.encryptedSignatureIpfsUrl ? `/membership-certificate/${user.id}` : null
  // });

  return (<>
    <Box
      bg={getComponent("footer", "bg", colorMode)}
      borderTop="1px solid"
      borderColor={getColor("border.light", colorMode)}
      py={8}
      mt="auto" // This pushes the footer to the bottom
    >
      <Container as="footer" role="contentinfo" maxW="6xl">
        <VStack spacing={8}>
          {/* Main Footer Content */}
          <SimpleGrid
            columns={{ base: 1, md: 3 }}
            gap={8}
            width="full"
          >
            {/* Brand Section */}
            <VStack align="start" spacing={4}>
              <Logo textColor={getColor("secondary", colorMode)} />
              <Text fontSize="sm" color={getComponent("footer", "text", colorMode)} maxW="280px" fontStyle="italic">
                {brandConfig.tagline}
              </Text>
              <Text fontSize="xs" color={getComponent("footer", "text", colorMode)} maxW="280px">
                Serving values-led organisations across Australia.
              </Text>
            </VStack>

            {/* Site Links Section */}
            <VStack align="start" spacing={4}>
              <Text fontSize="xs" fontWeight="500" letterSpacing="0.12em" textTransform="uppercase" color={colorMode === 'light' ? getColor("text.primary", colorMode) : "white"}>
                Navigation
              </Text>
              <VStack align="start" spacing={2}>
                {siteLinks.map((link) => (
                  <Link
                    key={link.label}
                    color={getComponent("footer", "linkColor", colorMode)}
                    fontSize="sm"
                    fontWeight="400"
                    transition="all 0.2s ease"
                    cursor="pointer"
                    onClick={() => scrollTo(link.anchor)}
                    _hover={{
                      color: getComponent("footer", "linkHover", colorMode),
                      textDecoration: "none"
                    }}
                  >
                    {link.label}
                  </Link>
                ))}
              </VStack>
            </VStack>

            {/* Contact Section */}
            <VStack align="start" spacing={4}>
              <Text fontSize="xs" fontWeight="500" letterSpacing="0.12em" textTransform="uppercase" color={colorMode === 'light' ? getColor("text.primary", colorMode) : "white"}>
                Contact
              </Text>
              <VStack align="start" spacing={2}>
                <Text fontSize="sm" color={getComponent("footer", "text", colorMode)}>
                  {brandConfig.contact.businessType}
                </Text>
                {brandConfig.contact.email && (
                  <Link
                    href={`mailto:${brandConfig.contact.email}`}
                    fontSize="sm"
                    color={getComponent("footer", "linkColor", colorMode)}
                    _hover={{ color: getComponent("footer", "linkHover", colorMode), textDecoration: "none" }}
                  >
                    {brandConfig.contact.email}
                  </Link>
                )}
                {accountLinks.length > 0 && (
                  <VStack align="start" spacing={1} mt={4}>
                    <Text fontSize="xs" fontWeight="500" letterSpacing="0.12em" textTransform="uppercase" color={colorMode === 'light' ? getColor("text.primary", colorMode) : "white"} mb={1}>
                      Account
                    </Text>
                    {accountLinks.map((link) => (
                      <Link
                        key={link.label}
                        as={RouterLink}
                        to={link.href}
                        color={getComponent("footer", "linkColor", colorMode)}
                        fontSize="sm"
                        _hover={{ color: getComponent("footer", "linkHover", colorMode), textDecoration: "none" }}
                      >
                        {link.label}
                      </Link>
                    ))}
                  </VStack>
                )}
              </VStack>
            </VStack>
          </SimpleGrid>

          {/* Acknowledgement of Country */}
          <Divider borderColor={getColor("border.light")} />
          <Box w="full" py={2}>
            <Text
              fontSize="xs"
              color={getComponent("footer", "text", colorMode)}
              lineHeight="1.8"
              fontStyle="italic"
              textAlign={{ base: "left", md: "center" }}
              maxW="720px"
              mx="auto"
            >
              L. James Solutions acknowledges the Traditional Owners and Custodians of the many First Nations Countries across Australia where I live, work, and travel. I pay my respects to Elders past and present, and to the next generation who carry culture forward. I commit to listening, learning, and acting in ways that honour these enduring connections to land, water, and community.
            </Text>
          </Box>

          {/* Bottom Bar */}
          <Divider borderColor={getColor("border.light")} />

          <HStack justify="space-between" w="full" flexWrap="wrap" spacing={4}>
            <Text fontSize="xs" color={getComponent("footer", "text", colorMode)}>
              &copy; {new Date().getFullYear()} {brandConfig.siteName}. Australia.
            </Text>

            <HStack spacing={6} flexWrap="wrap">
              <Link
                as={RouterLink}
                to="/governance"
                fontSize="xs"
                color={getComponent("footer", "linkColor", colorMode)}
                _hover={{
                  color: getComponent("footer", "linkHover", colorMode),
                  textDecoration: "none"
                }}
              >
                Privacy
              </Link>
              <Link
                as={RouterLink}
                to="/governance"
                fontSize="xs"
                color={getComponent("footer", "linkColor", colorMode)}
                _hover={{
                  color: getComponent("footer", "linkHover", colorMode),
                  textDecoration: "none"
                }}
              >
                Terms
              </Link>
            </HStack>
          </HStack>
        </VStack>
      </Container>
    </Box>

  </>
  )
}